
import { Link, useLocation } from "react-router-dom";

interface MobileMenuProps {
  isMenuOpen: boolean;
  setIsMenuOpen: (isOpen: boolean) => void;
  isEnglish: boolean;
  isSwedish: boolean;
  isArabic: boolean;
  isHebrew: boolean;
  isArticlePage?: boolean;
}

const MobileMenu = ({ 
  isMenuOpen, 
  setIsMenuOpen, 
  isEnglish, 
  isSwedish, 
  isArabic, 
  isHebrew,
  isArticlePage = false
}: MobileMenuProps) => {
  const location = useLocation();
  
  console.log("🍔 MobileMenu render - isMenuOpen:", isMenuOpen);
  
  // Article pages should use Finnish navigation
  const useFinishNav = !isEnglish && !isSwedish && !isArabic && !isHebrew || isArticlePage;
  
  // Base path based on language - using only short language codes
  const basePath = useFinishNav
    ? ""
    : isEnglish 
      ? "/en" 
      : isSwedish 
        ? "/sv" 
        : isArabic 
          ? "/ar"
          : "/he";
  
  // Navigation items with conditional paths based on language
  const navItems = [
    {
      id: "kilpailuta",
      label: useFinishNav
        ? "Kilpailuta laina"
        : isEnglish 
          ? "Apply for loan" 
          : isSwedish 
            ? "Ansök om lån" 
            : isArabic 
              ? "التقدم للحصول على قرض"
              : "בקש הלוואה",
      path: useFinishNav 
        ? "/kilpailuta"
        : `${basePath}/apply`
    },
    {
      id: "lainat",
      label: useFinishNav
        ? "Lainatuotteet"
        : isEnglish 
          ? "Loan products" 
          : isSwedish 
            ? "Låneprodukter" 
            : isArabic 
              ? "منتجات القروض"
              : "מוצרי הלוואה",
      path: useFinishNav
        ? "/lainatuotteet"
        : `${basePath}/products`
    },
    {
      id: "articles",
      label: useFinishNav
        ? "Artikkelit & Oppaat"
        : isEnglish 
          ? "Guides" 
          : isSwedish 
            ? "Guider" 
            : isArabic 
              ? "أدلة"
              : "מדריכים",
      path: useFinishNav
        ? "/artikkelit"
        : `${basePath}/info`
    },
    {
      id: "meista",
      label: useFinishNav
        ? "Meistä"
        : isEnglish 
          ? "About" 
          : isSwedish 
            ? "Om oss" 
            : isArabic 
              ? "معلومات عنا"
              : "אודות",
      path: useFinishNav
        ? "/meista"
        : `${basePath}/info`
    },
    {
      id: "yhteystiedot",
      label: useFinishNav
        ? "Yhteystiedot"
        : isEnglish 
          ? "Contact" 
          : isSwedish 
            ? "Kontakt" 
            : isArabic 
              ? "اتصل"
              : "צור קשר",
      path: useFinishNav
        ? "/yhteystiedot"
        : `${basePath}/info`
    }
  ];

  const handleMenuClose = () => {
    console.log("🍔 Closing mobile menu");
    setIsMenuOpen(false);
  };

  if (!isMenuOpen) {
    console.log("🍔 Menu is closed, not rendering content");
    return null;
  }

  console.log("🍔 Menu is open, rendering content");

  return (
    <div className="fixed inset-0 top-[80px] bg-white border-t border-gray-200 z-50 overflow-y-auto">
      <div className="container mx-auto px-4 py-6">
        <nav className="flex flex-col space-y-1">
          {navItems.map((item) => (
            <Link
              key={item.id}
              to={item.path}
              className="px-4 py-4 font-medium rounded-lg text-blue-600 hover:bg-blue-50 hover:text-blue-800 transition-colors text-lg border-b border-gray-100 last:border-b-0"
              onClick={handleMenuClose}
            >
              {item.label}
            </Link>
          ))}
          
          {/* Language links - ONLY use standard short codes */}
          <div className="pt-6 mt-6 border-t border-gray-200">
            <p className="px-4 text-base font-medium text-gray-500 mb-4">
              {isEnglish ? "Select language:" : 
               isSwedish ? "Välj språk:" : 
               isArabic ? "اختر اللغة:" :
               isHebrew ? "בחר שפה:" :
               "Valitse kieli:"}
            </p>
            <div className="flex flex-col space-y-1">
              <Link to="/" className="px-4 py-3 text-base hover:bg-blue-50 rounded-lg transition-colors" onClick={handleMenuClose}>
                🇫🇮 Suomi
              </Link>
              <Link to="/en" className="px-4 py-3 text-base hover:bg-blue-50 rounded-lg transition-colors" onClick={handleMenuClose}>
                🇬🇧 English
              </Link>
              <Link to="/sv" className="px-4 py-3 text-base hover:bg-blue-50 rounded-lg transition-colors" onClick={handleMenuClose}>
                🇸🇪 Svenska
              </Link>
              <Link to="/ar" className="px-4 py-3 text-base hover:bg-blue-50 rounded-lg transition-colors" onClick={handleMenuClose}>
                🇸🇦 العربية
              </Link>
              <Link to="/he" className="px-4 py-3 text-base hover:bg-blue-50 rounded-lg transition-colors" onClick={handleMenuClose}>
                🇮🇱 עברית
              </Link>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default MobileMenu;
